(function () {
  if (window.santaSocialMediaInitialized) return;
  window.santaSocialMediaInitialized = true;

  const initAutoSliders = (selector) => {
    const sliders = document.querySelectorAll(selector);

    if (sliders && sliders.length > 0) {
      sliders.forEach(el => {
        if (el.swiper) return;

        const speed = el.getAttribute('data-duration');

        new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 1,
          loop: true,
          shortSwipes: false,
          longSwipes: false,
          allowTouchMove: false,
          autoplay: {
            delay: 2000
          },
          speed: speed
        });
      });
    }
  }

  const initSliders = () => {
    initAutoSliders('.js-social-media');
    initAutoSliders('.js-social-media-slow');
  }

  const initHowStartSliders = () => {
    const sliders = document.querySelectorAll('[data-how-start-slider]');

    sliders.forEach(slider => {
      if (slider.dataset.howStartInitialized === 'true') return;

      const track = slider.querySelector('[data-how-start-track]');
      const slides = Array.from(slider.querySelectorAll('[data-how-start-slide]'));
      const previousButton = slider.querySelector('[data-how-start-prev]');
      const nextButton = slider.querySelector('[data-how-start-next]');
      const dots = Array.from(slider.querySelectorAll('[data-how-start-dot]'));

      if (!track || slides.length === 0) return;

      let currentIndex = 0;
      let scrollTimeout;

      const getSlideStep = () => {
        if (slides.length < 2) return slides[0].getBoundingClientRect().width;

        return slides[1].offsetLeft - slides[0].offsetLeft;
      };

      const update = () => {
        const slideStep = getSlideStep();
        currentIndex = slideStep > 0 ? Math.round(track.scrollLeft / slideStep) : 0;
        currentIndex = Math.max(0, Math.min(currentIndex, slides.length - 1));

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === currentIndex);
        });

        if (previousButton) previousButton.disabled = currentIndex === 0;
        if (nextButton) nextButton.disabled = currentIndex === slides.length - 1;
      };

      const scrollToIndex = index => {
        const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
        const slideStep = getSlideStep();

        track.scrollTo({
          left: slideStep * nextIndex,
          behavior: 'smooth'
        });
      };

      previousButton?.addEventListener('click', () => scrollToIndex(currentIndex - 1));
      nextButton?.addEventListener('click', () => scrollToIndex(currentIndex + 1));

      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimeout);
        scrollTimeout = window.setTimeout(update, 80);
      }, { passive: true });

      window.addEventListener('resize', update);
      update();

      slider.dataset.howStartInitialized = 'true';
    });
  }

  const observedSections = new WeakSet();

  const sectionResizeObserver = new ResizeObserver((entries) => {
    entries.forEach(entry => {
      const sliders = entry.target.querySelectorAll('.js-social-media, .js-social-media-slow');

      if (sliders.length != 0) {
        sliders.forEach(slider => {
          if (slider.swiper)
            slider.swiper.update();
        })
      }

      initSliders();
      initHowStartSliders();
    });
  });

  const initSection = () => {
    const socialMediaSection = document.querySelectorAll('.social-media-section');

    socialMediaSection.forEach(section => {
      if (observedSections.has(section)) return;

      observedSections.add(section);
      sectionResizeObserver.observe(section);
    });
  }

  document.addEventListener('shopify:section:load', function () {
    initSliders();
    initHowStartSliders();
    initSection();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!observedSections.has(event.target)) return;

    sectionResizeObserver.unobserve(event.target);
    observedSections.delete(event.target);
  });

  initSliders();
  initHowStartSliders();
  initSection();
})();
